<template>
    <div class="home-page">
      <div class="header-bgfff bgfff">
        <Header></Header>
        <div class="nav ac">
          <div class="back" @click="back">
            <img width="80" src="../../static/images/back2.png" />
          </div>
          <div class="nav-t"><span>{{$t('BeginnerTips2')}}</span></div>
        </div>
      </div>
		<div class="home-content">
      <div class="content crfff ac por">
        <div class="list-content">
          <div class="home-block5" v-for="(item,index) in list" @click="getToNav(item)">
            <div class="img-box">
              <img :src="item.cover_image" loading="lazy">
              <span class="status-badge" :class="'status-' + item.status">
                {{ statusText(item.status) }}
              </span>
            </div>

            <div class="home-block5-c disflex">
              <div class="block2-font">
                <div class="fw7">{{item.title}}</div>
              </div>
              <div class="learn button">{{$t('Watch')}}></div>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[]
      }
    },
	created(){
    this.getList()
	},
    methods: {
      back(){
      	this.$router.push({path:'/',query: {}});
      },
      getToNav(item){
        this.$router.push({path:'/BeginnerDetail',query: {id:item.id}});
      },
      getList(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/pinyin/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
	}
}
</script>
<style scoped>
.img-box {
  position: relative;
  display: inline-block;
}
.img-box img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/Beginner.vue